import React, { useCallback, useMemo, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import { selectIsUserAuthenticated } from 'features/auth/selectors'
import { selectLocaleDict } from 'features/locale/selectors'
import { hidePersonalJackpotNotify } from 'features/notifies/actions'
import { selectNotifies } from 'features/notifies/selectors'

import NotifyContainer from '../NotifyContainer/NotifyContainer'
import PersonalJackpotsPolling from './PersonalJackpotsPolling/PersonalJackpotsPolling'

const PersonalJackpotNotify = () => {
  const dispatch = useDispatch()

  const isAuth = useSelector(selectIsUserAuthenticated, shallowEqual)
  const locale = useSelector(selectLocaleDict, shallowEqual).bonuses
  const { all: allJackpots, hide: hiddenJackpots } = useSelector(selectNotifies, shallowEqual).personalJackpot

  const [temporarilyClosedJackpots, setTemporarilyClosedJackpots] = useState<number[]>([])

  const hideNotify = useCallback(
    (id: number) => {
      dispatch(hidePersonalJackpotNotify(id))
    },
    [dispatch],
  )

  const temporarilyHideNotify = useCallback(
    (id: number) => {
      setTemporarilyClosedJackpots(prev => [...prev, id])
      hideNotify(id)
    },
    [hideNotify],
  )

  const items = useMemo(
    () =>
      Object.keys(allJackpots)
        .filter(jackpotId => !hiddenJackpots.includes(+jackpotId) && !temporarilyClosedJackpots.includes(+jackpotId))
        .map(jackpot => {
          const currId = Number(jackpot)
          const amount = allJackpots[currId]?.amount
          const currency = allJackpots[currId]?.amountCurrency

          return (
            <NotifyContainer
              key={currId}
              title={locale.yourJackpot}
              value={amount}
              currency={currency}
              callback={() => hideNotify(currId)}
              backgroundCallback={() => temporarilyHideNotify(currId)}
            />
          )
        }),
    [allJackpots, hiddenJackpots, hideNotify, temporarilyHideNotify, locale.yourJackpot, temporarilyClosedJackpots],
  )

  return isAuth ? (
    <>
      <PersonalJackpotsPolling />
      {items}
    </>
  ) : null
}

export default PersonalJackpotNotify
